import h, { FunctionComponent } from 'preact';
import { OrderType } from './index';

const OrderTypes: FunctionComponent<OrderTypesProps> = ({ selectedOrderType, orderTypes, canChange, onChange }) => {
    return <div class="col-3 offset-6">
            <label htmlFor="checkout-forwardordering">
                Place order as: (<a href="https://oneandall.co.uk/forward-orders" target="_blank" rel="noopener">?</a>)
            </label>
            <select
                name="orderType"
                id="checkout-forwardordering"
                class="form-control custom-select"
                disabled={!canChange}
                defaultValue={selectedOrderType === null ? '' : selectedOrderType}
                onChange={e => {
                    const v = (e.target as HTMLSelectElement).value;
                    onChange(v === '' ? null : v);
                }}
            >
                <option value="">Day to day</option>
                {orderTypes.filter(ot => ot.visible && ot.due_date !== null).map(ot => (
                    <option value={ot.alias}>{ot.name}</option>
                ))}
            </select>
        </div>
    ;
};

interface OrderTypesProps {
    selectedOrderType: string | null;
    orderTypes: Array<OrderType>;
    canChange: boolean;
    onChange: (alias: string | null) => void;
}

export default OrderTypes;
